import React, { useState } from 'react'
import { useStore } from '../../store/store';
import { ItemTypes, MASKS_TYPE, getPrimaryDark } from '../../constants/constants';
import { isADefaultBox, isADrawBox, isAOneRowBox, isAVariableBox } from '../../utils/boxes';
import { copyDragItem } from '../../utils/copies';
import { Button } from 'antd';
import Tooltip from './Tooltip';
import { useDrag } from 'react-dnd';
import { useTranslation } from 'react-i18next';
import { acceptsInPageBackground, isPageBackgroundId } from '../../utils/pageBackground';
import {
  PALETTE_TILE_BODY_STYLE, PALETTE_TILE_LABEL_STYLE, paletteTileStyle,
} from '../../shared/ui/paletteTile';


// Bleu du presse-papiers assombri : les vignettes copiées ont une icône blanche,
// la teinte de survol claire des autres boutons la rendait illisible.
const COPY_TILE_BG_HOVER = '#24559F';

const BoxButton = ({ type, text, icon, bgcolor, disp, label, color = '#000000', onDragStart,
  onClick, size = 38, canDrag = true, marginLeft = 5, marginBottom = 8, copy, showLabel = false
}) => {
  const { i18n } = useTranslation();
  const maskEditing = useStore(({ maskEditing }) => maskEditing);
  const isInMask = maskEditing.length > 0
  const isInHeaderFooter = isInMask &&
    (maskEditing.includes(MASKS_TYPE.HEADER.id) || maskEditing.includes(MASKS_TYPE.FOOTER.id))
  // Le décor de page n'accepte que traits, formes et images (cf. ColumnWrapper).
  const isInPageBackground = isInMask && maskEditing.some(isPageBackgroundId)
  const disabled = (isInMask && (isADrawBox(type) || isADefaultBox(type) || isAVariableBox(type) || type === ItemTypes.ORG_CHART)) ||
    (isInHeaderFooter && isAOneRowBox(type)) ||
    (isInPageBackground && !acceptsInPageBackground(type))
  const gridConfiguration = useStore(({ gridConfiguration }) => gridConfiguration);
  const isTemplate = useStore(({ currentDocument }) => currentDocument?.type === 'template');
  const accentColor = getPrimaryDark(isTemplate);
  const [isHovered, setIsHovered] = useState(false);
  const isCopyTile = !!copy;
  const hovered = isHovered && !disabled;
  const [, drag] = useDrag({
    type: type === ItemTypes.CONTAINER_COPIED ? ItemTypes.CONTAINER_COPIED : 'newBox',
    item: copy ? copyDragItem(copy) : { type, ...gridConfiguration[type], copied: false },
    canDrag: !disabled && canDrag
  });

  const li = (
    <li
      ref={drag}
      onDragStart={onDragStart}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        ...paletteTileStyle({ background: bgcolor, hovered, accentColor, color }),
        display: disp,
        marginLeft,
        marginBottom,
        width: showLabel ? '100%' : size,
        height: showLabel ? 'auto' : size,
        aspectRatio: showLabel ? '1 / 1' : undefined,
        fontSize: '9px',
        // Ombre et bleu propres au survol d'une vignette copiée : changer la
        // teinte de bleu ne suffit pas à signaler l'élément visé.
        ...(hovered && isCopyTile ? {
          backgroundColor: COPY_TILE_BG_HOVER,
          borderColor: COPY_TILE_BG_HOVER,
          color,
          boxShadow: '0 2px 8px rgba(36, 85, 159, 0.45)',
        } : {}),
      }}
    >
      <Button
        onClick={onClick}
        style={{
          ...(showLabel ? PALETTE_TILE_BODY_STYLE : {
            display: 'flex', flexDirection: 'row', width: '100%', height: '100%',
            justifyContent: 'center', alignItems: 'center',
          }),
          borderStyle: 'none',
          boxShadow: 'none',
          backgroundColor: 'transparent',
          color: 'inherit',
          whiteSpace: showLabel ? 'normal' : undefined,
        }}
        icon={icon}
        disabled={disabled}
      >{showLabel
        ? <span lang={i18n.language} style={{ ...PALETTE_TILE_LABEL_STYLE, marginInlineStart: 0 }}>{text}</span>
        : label}</Button>
    </li>
  );

  if (showLabel) return li;

  return (
    <Tooltip
      // Les vignettes copiées sont en tête de panneau : une infobulle en dessous
      // recouvrirait la liste des éléments disponibles.
      placement={isCopyTile ? 'top' : 'bottom'}
      mouseLeaveDelay='0'
      title={text}
      mouseEnterDelay={0.5}
      // AdderMenu ("Ajouter une ligne") est en zIndex 10001 ; le tooltip antd
      // par défaut (1070) passait DERRIERE le modal -> invisible. On le remonte.
      zIndex={10050}
    >
      {li}
    </Tooltip>
  );
};

export default BoxButton
